import React, { FC, useCallback, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { getBusinessEntityDetailsData } from '../../../../store/selectors'
import { UpdateBusinessEntityDetailsModal } from '../UpdateBusinessEntityDetailsModal'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
  sectionName: {
    fontWeight: 600,
    fontSize: 28,
    color: theme.palette.primary.light,
  },
  field: {
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.light,
  },
  fieldTitle: {
    fontWeight: 500,
    fontSize: 20,
  },
  fieldContent: {
    fontSize: 16,
    wordWrap: 'break-word',
  },
}))

export const BusinessEntityDetails: FC = () => {
  const classes = useStyles()
  const { id } = useParams<{ [key: string]: string }>()
  const entity = useSelector(getBusinessEntityDetailsData)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const onCloseEditModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  const onOpenEditModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  return (
    <Grid container className={classes.container}>
      <Grid container item xs={11} gap={3}>
        <Typography className={classes.sectionName}>Details</Typography>
        <Grid item xs={12} className={classes.field}>
          <Typography className={classes.fieldTitle}>Name: </Typography>
          <Typography className={classes.fieldContent}>{entity?.name || '-'}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.field}>
          <Typography className={classes.fieldTitle}>Description: </Typography>
          <Typography className={classes.fieldContent}>{entity?.description || '-'}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.field}>
          <Typography className={classes.fieldTitle}>Active: </Typography>
          <Typography className={classes.fieldContent}>{entity?.active.toString() || '-'}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.field}>
          <Typography className={classes.fieldTitle}>Created: </Typography>
          <Typography className={classes.fieldContent}>
            {new Date(entity?.createdAt as Date).toLocaleString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }) || '-'}
          </Typography>
        </Grid>
      </Grid>
      <Grid container item xs={1} justifyContent={'flex-end'}>
        <GreenButton text="Edit" width={120} onClick={onOpenEditModal} />
      </Grid>
      <UpdateBusinessEntityDetailsModal id={id} isOpen={isOpen} modalClose={onCloseEditModal} />
    </Grid>
  )
}
